import "../../external/axios/index.js";
import { useQuery as $ } from "@tanstack/react-query";
import d from "../../external/axios/lib/axios.js";
const y = (n, r, s, a, i = "web") => {
  const c = async () => {
    const { data: f } = await d.get(
      `${n}/${a}/${i}/${s}/${r}/${r}.tokens.json`
    );
    return f;
  }, { isLoading: u, data: o, error: t } = $({
    queryKey: ["theme", r],
    queryFn: c,
    refetchOnWindowFocus: !1
  });
  let e;
  return t instanceof Error && (e = `An error has occurred while fetching theme. Error: ${t.message}`), !u && o && (e = o), e;
};
export {
  y as useTheme
};
